export { ActivitiesNotificationComponent } from './activities-notification.component';



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/activities/activities-notification/index.ts